import React from "react";
import HeaderOne from "../components/HeaderOne";
import { Helmet } from "react-helmet-async";
import FooterAreaOne from "../components/FooterAreaOne";
import Breadcrumb from "../components/Breadcrumb";
import SubscribeOne from "../components/SubscribeOne";
import Preloader from "../helper/Preloader";
import useInitialLoad from "../helper/useInitialLoad";
import MecanicaServicesData from "../components/MecanicaServicesData";

const MecanicaServicePage = () => {
  const showPreloader = useInitialLoad(2000);

  return (
    <>
      {/* Preloader */}
      {showPreloader && <Preloader />}

      {/* Header one */}
      <HeaderOne />

      <Helmet>
        <title>Taller Mecánica Sevilla | Embrague, Distribución, Frenos | Leal</title>
        <meta name="description" content="Taller mecánica en Sevilla y Mairena del Aljarafe. Embrague, distribución, frenos, suspensión, diagnóstico. +15 años experiencia. Presupuesto sin compromiso." />
        <meta name="keywords" content="taller mecánica Sevilla, mecánica Mairena Aljarafe, embrague Sevilla, distribución coche, frenos suspensión, diagnóstico electrónico, taller PISA, Pre-ITV Sevilla" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Taller Mecánica Sevilla | Profesionales con +15 años" />
        <meta property="og:description" content="Taller mecánica en Mairena del Aljarafe. Embrague, distribución, frenos, suspensión. Diagnóstico profesional. Presupuesto gratis." />
        <meta property="og:url" content="https://www.lealchapaypintura.com/mecanica" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_ES" />
        <meta property="og:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Taller Mecánica Sevilla | +15 años experiencia" />
        <meta name="twitter:description" content="Embrague, distribución, frenos, suspensión. Diagnóstico profesional en Sevilla." />
        <meta name="twitter:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <link rel="canonical" href="https://www.lealchapaypintura.com/mecanica" />
      </Helmet>

      {/* Breadcrumb */}
      <Breadcrumb
        title="Mecánica"
        parents={[{ label: "Servicios", path: "/#servicios" }]}
      />

      {/* Service Area One */}
      <MecanicaServicesData title={"Mecánica"} />

      {/* Subscribe One */}
      <SubscribeOne />

      {/* Footer Area One */}
      <FooterAreaOne />
    </>
  );
};

export default MecanicaServicePage;
